import {Component, inject, OnInit} from '@angular/core';
import {HttpClient, HttpContext} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {QuillViewHTMLComponent} from "ngx-quill";
import {IGNORE_5XX_ERROR} from "../../../interceptors/http500_interceptor";

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    QuillViewHTMLComponent
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent implements OnInit {
  http = inject(HttpClient);
  newsContent: string;
  readonly context = new HttpContext();


  constructor() {
    this.context.set(IGNORE_5XX_ERROR, true)
  }

  ngOnInit(): void {
    this.http.get<any>(`${environment.masterUrl}/api/news/content/SRM`,{context: this.context}).subscribe(res => {
      if (res?.textDetail) {
        this.newsContent = res.textDetail;
      }
    });
  }
}
